<template>
  <section
    :class="{'view-navigation-bar--absolute': hideTitle}"
    class="view-navigation-bar"
  >
    <div class="columns align-center is-mobile is-marginless is-gapless">
      <div
        v-if="!hideTitle"
        class="column is-flex"
      >
        <IconButton
          v-if="hasBackButton"
          background="transparent"
          ripple-color="#EAEDF0"
          icon="left-arrow"
          @click="goBack()"
        />
        <div
          :class="
            [`navigation-descriptions--${navigationLink && navigationLink.position || 'block'}`,
             {'has-margin-left-2' : hasBackButton },
             {'justify-center' : !subtitle &&
               (!navigationLink || navigationLink.position === 'inline') }
            ]"
          class="navigation-descriptions"
        >
          <div
            class="is-flex direction-column"
          >
            <div class="is-flex align-center">
              <h1 class="title has-margin-0">
                {{ title }}
              </h1>
              <IconButton
                v-if="helpId !== '' && user?.profile.helpdesk === 'S'"
                :size="20"
                :padding="0"
                :color="helpColor"
                icon="info"
                background="transparent"
                class="has-margin-left-1"
                @click="handleHelpdesk"
              />
            </div>
            <h2
              v-if="subtitle"
              class="navigation-subtitle"
            >
              {{ subtitle }}
            </h2>
          </div>
          <LinkButton
            v-if="navigationLink"
            :label="navigationLink.label"
            :icon-size="15"
            :icon="navigationLink.icon || 'lens'"
            class="navigation-link"
            label-classes="has-text-weight-medium is-size-11"
            color="#FF2D55"
            @click="handleLinkClick"
          />
        </div>
      </div>
      <div
        :class="{'is-2': !hideTitle, 'is-12': hideTitle}"
        class="column is-narrow action-buttons-container"
      >
        <slot name="action-buttons" />
        <IconButton
          v-if="hasList && hasRefreshButton"
          rotate
          background="transparent"
          ripple-color="#EAEDF0"
          icon="reload"
          @click="$bus.emit('refresh')"
        />
      </div>
    </div>
  </section>
</template>

<script>

import { mapState } from 'pinia';
import { useRootStore } from '@/stores/root';
import IconButton from '@/components/buttons/IconButton.vue';
import LinkButton from '@/components/buttons/LinkButton.vue';

export default {
  name: 'ViewNavigationBar',
  components: {
    IconButton,
    LinkButton,
  },
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    backRoutePath: { type: String, default: '' },
    backRouteName: { type: String, default: '' },
    hasBackWarning: { type: Boolean, default: false },
    hasRefreshButton: { type: Boolean, default: false },
    hasBackButton: { type: Boolean, default: false },
    navigationLink: { type: Object, default: () => {} },
    helpId: { type: String, default: '' },
    helpColor: { type: String, default: '#C7C7C7' },
    hideTitle: { type: Boolean, default: false },
  },
  emits: ['backClick', 'linkClick'],
  computed: {
    // Vuex mapGetters → Pinia rootStore.
    ...mapState(useRootStore, ['hasList', 'user']),
  },
  methods: {
    goBack() {
      if (this.hasBackWarning) this.$emit('backClick');
      else if (this.backRoutePath) this.$router.push(this.backRoutePath);
      else if (this.backRouteName) this.$router.push({ name: this.backRouteName });
      else this.$router.back();
    },
    handleLinkClick() {
      if (this.navigationLink.path) this.$router.push(this.navigationLink.path);
      this.$emit('linkClick');
    },
    handleHelpdesk() {
      // Vite: process.env.VUE_APP_* → import.meta.env.VITE_*.
      window.open(`${import.meta.env.VITE_HELPDESK_URL}?id=${this.helpId}`);
    },
  },
};
</script>

<style lang="scss">


.view-navigation-bar{
  padding-bottom: 10px;

  &--absolute {
    position: absolute;
    right: 1.25rem;
  }

  .navigation-subtitle {
    font-size: $size-8;
    color: $grey-bermuda;
    font-weight: $weight-medium;
  }

  .navigation-descriptions {
    display: flex;
    &--inline {
      flex-direction: column;
      @include from($tablet) {
        flex-direction: row;
        .navigation-link {
          align-self: flex-end;
          margin-bottom: 4px;
          margin-left: 0.5rem;
        }
      }

    }
    &--block {
      flex-direction: column;
    }
  }
  .action-buttons-container {
    display: flex;
    justify-content: flex-end;
    align-self: flex-start;
  }
}

</style>
